import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Draggable from 'react-draggable';
import classes from './DraggableModal.module.scss';

const DraggableModal = ({ title, onClose, show, children, ...otherProps }) => {
  const isImage = useMemo(() => {
    const arr = React.Children.toArray(children).filter(Boolean);
    if (arr.length !== 1) return false;
    const el = arr[0];
    return React.isValidElement(el) && (el.type === 'img' || el.props.src);
  }, [children]);

  if (!show) return null;

  return ReactDOM.createPortal(
    <div className={classes.overlay}>
      <Draggable 
        handle=".draggable-bar" 
        // Убрали bounds, чтобы не было "мертвых зон" при таскании
        {...otherProps}
      >
        <div className={classnames(classes.modal, { [classes.isImageModal]: isImage })}>
          <div className={classnames('draggable-bar', classes.bar)}>
            <div className={classes.title}>{title}</div>
            <button className={classes.closeBtn} onClick={onClose} type="button">×</button>
          </div>
          <div className={classnames(classes.content, { [classes.isImageContent]: isImage })}>
            {children}
          </div>
        </div>
      </Draggable>
    </div>,
    document.body
  );
};

DraggableModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node,
  children: PropTypes.node,
};

export default DraggableModal;